<template>
  <div class="flex min-w-0 items-center gap-1 text-label">
    <provider-image :provider="callerInfo.provider" alt="Call Provider Icon" />
    <span
      v-if="callerInfo.from"
      v-tooltipable.collapsed="callerInfo.fromPhone"
      class="min-w-0 truncate"
    >
      {{ callerInfo.from }}
    </span>
    <template v-if="callerInfo.to">
      <span class="shrink-0 whitespace-nowrap">
        {{ $t("ACTIVITY.CONTACTS.REACHED_TO").toLowerCase() }}:
      </span>
      <span
        v-tooltipable.collapsed="callerInfo.toPhone"
        class="min-w-0 truncate"
      >
        {{ callerInfo.to }}
      </span>
    </template>
    <date-time
      :date="item.created_at"
      class="ml-auto shrink-0 whitespace-nowrap"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import ProviderImage from "@/components/communicationLogs/communication/ProviderImage.vue";
import DateTime from "@/components/ui/ConvertibleDateTime.vue";

import type { CallLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: CallLogData;
}>();

const callerInfo = computed(() => {
  const { is_outgoing, provider, from: fromPhone, to: toPhone } = item;
  const { full_name } = item.user ?? {};
  const { name } = item.callee ?? {};
  const from = is_outgoing ? full_name : name;
  const to = is_outgoing ? name : full_name;

  return { from, to, fromPhone, toPhone, provider };
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";
</style>
